import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Badge, Button, Table, Progress } from "reactstrap";
import "../../assets/css/--page-account-order-details.css";
import { useNavigate } from "react-router-dom";
import { getOrderlist, formatDate } from "../../helper/backend-methods";
import statuses from "../../data/statuses";
import noOrder from "../../assets/images/no-order.png";
import AppLoader from "../../components/AppLoader";

function CurrentOrders(props) {
  const history = useNavigate();
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(true);
  const [orderedProducts, setOrderedProducts] = useState([]);

  useEffect(() => {
    getOrderlist({ orderStatus: "all" })
      .then(({ data }) => {
        setLoading(true);
        if (data.Status) {
          data.Data.OrderList.map((o) => {
            o.OrderDate = formatDate(o.OrderDate);
            return o;
          });
          let message = "";
          const currentOrders = data.Data.OrderList.filter(
            (o) => o.CurrentStatus !== "Order Picked Up" && o.CurrentStatus !== "Delivered" && o.CurrentStatus !== "Cancelled"
          );
          currentOrders.forEach((order) => {
            if (order.CurrentStatus === "Received") {
              order.progress = statuses.Received.progress;
              message = statuses.Received.currentOrderMessage;
            } else if (order.CurrentStatus === "Preparing") {
              order.progress = statuses.Preparing.progress;
              message = statuses.Preparing.currentOrderMessage;
            } else if (order.CurrentStatus === "Ready For Pickup") {
              order.progress = statuses.ReadyForPickup.progress;
              message = statuses.ReadyForPickup.currentOrderMessage;
            } else if (order.CurrentStatus === "Order Picked Up") {
              order.progress = statuses.OrderPickedUp.progress;
              message = statuses.OrderPickedUp.currentOrderMessage;
            }
            order.message = message;
          });
          setOrderedProducts(currentOrders);
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  }, []);

  return (
    <div className="mt-5 ms-md-4 ms-sm-0">
      <div className="order-heading d-flex align-items-center mb-4">
        <h1 className="fs-30 text-blakish fw-600 m-0">Current Orders</h1>
        <div className="order-count fs-16 d-flex align-items-center gap-2 ms-4">
          <span className="fw-600 fs-30">{String(orderedProducts.length).padStart(2, "0")}</span> Active Orders
        </div>
      </div>
      <span className="separator mt-4 mb-5"></span>
      <div className="current-order-inner">
        {orderedProducts.length ? (
          orderedProducts.map((order, index) => {
            return (
              <div className="order-progress-card mb-4" key={index}>
                <CardBody>
                  {/* Header Section */}
                  <div className="order-progress-header d-flex justify-content-between align-items-start flex-wrap">
                    <div className="d-flex flex-wrap w-100">
                      <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-3">
                        <div className="label text-black fw-600 fs-18">Order No.</div>
                        <div className="value text-gray fw-400 fs-18">{order.OrderNo}</div>
                      </div>
                      <div className="col-12 col-sm-6 col-md-3 mb-2 mb-md-3">
                        <div className="label text-black fw-600 fs-18">Date & Time</div>
                        <div className="value text-gray fw-400 fs-18">{order.OrderDate}</div>
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-3">
                        <div className="label text-black fw-600 fs-18">Order Type</div>
                        <div className="value text-gray fw-400 fs-18">{"Pickup"}</div>
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-2 mb-md-3">
                        <div className="label text-black fw-600 fs-18">Status</div>
                        <span className={`status-badge ${order.CurrentStatus.toLowerCase().replace(/\s/g, "")}`}>
                          {order.CurrentStatus}
                        </span>
                      </div>
                      <div className="col-12 col-md-3 mb-2 mb-md-0">
                        <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-sm-end gap-2 gap-sm-3">
                          <div className="order-total pe-0 pe-sm-3 text-center text-sm-start">
                            <div className="text-gray fw-400 fs-16">Total:</div>
                            <div className="text-black fw-800 fs-18">${order.TotalAmount}</div>
                          </div>
                          <div className="track-order w-100 w-sm-auto">
                            <button
                              color="primary"
                              className="track-btn w-80"
                              onClick={() => history("/account/order-track/" + order.OrderId)}
                            >
                              <i className="ri-eye-line me-1 fw-400"></i> TRACK ORDER
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="separator my-4"></span>
                  {/* Order Details */}
                  <div className="order-section mb-4">
                    <div className="section-title text-black fw-600 fs-18">Order Details</div>
                    <div className="section-text text-gray fw-400 fs-18">
                      {order?.productOrderDTO
                        .map((p) => p?.Quantity + " x " + p?.ProductName)
                        .filter(Boolean)
                        .join(", ")}
                    </div>
                  </div>

                  {/* Order Progress */}
                  <div className="order-section">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="section-title text-black fs-18">Order Progress</div>
                      <div className="estimated-time">{order.estimatedTime}</div>
                    </div>

                    <Progress
                      value={order.progress}
                      className={`custom-progress mt-2 progress-${order.CurrentStatus.toLowerCase().replace(/ /g, "")}`}
                    />

                    <div className="progress-message mt-4 text-gray fs-18">{order.message}</div>
                  </div>
                </CardBody>
              </div>
            );
          })
        ) : loading ? (
          <div className="loader-center">
            <AppLoader />
          </div>
        ) : (
          <div className="d-flex flex-column justify-content-center align-items-center flex-wrap text-center mt-5 pt-5">
            <img src={noOrder} alt="" />
            <h2 className="fs-36 fw-600 text-blakish mt-4">No Active Orders Yet</h2>
            <p className="fs-18 fw-600 text-blakish mt-2">
              Looks like you don't have any ongoing orders right now. When you place <br />
              an order, it'll show up here so you can track it in real time.
            </p>
            <button onClick={() => history("/menu")} className="explore-menu-btn mt-3">BROWSE MENU</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default CurrentOrders;
